import { removeInlineHeaderRanges } from './removeInlineHeaderRanges.js';
import { fixAtomicBlockText, addInlineStyleRanges, fixTextColorStyle, addLinkUnderlineRange } from './block-processors.js';
import { linkify } from './linkify.js';
import inlinePluginsRemover from './inlinePluginsRemover.js';
import { removeInvalidInlineStyles } from './removeInvalidInlineStyles.js';
import Version from '../version/versioningUtils.js';
import 'lodash';
import '../consts.js';
import 'ricos-schema';
import '../urlValidators/urlValidators.js';
import '../package-1966467e.js';

const contentStateProcessingStrategies = (config) => {
  const { disableInlineImages, removeInvalidInlinePlugins } = config;
  const strategies = [{ version: "<3.4.7", processors: [linkify] }];
  if (disableInlineImages) {
    strategies.push({
      version: "<8.0.0",
      processors: [inlinePluginsRemover({ imagesOnly: true })]
    });
  }
  if (removeInvalidInlinePlugins) {
    strategies.push({ version: "<8.0.0", processors: [inlinePluginsRemover()] });
  }
  return strategies;
};
const blockProcessingStrategies = {
  atomic: [{ processors: [fixAtomicBlockText] }],
  unstyled: [{ processors: [removeInlineHeaderRanges, addInlineStyleRanges, fixTextColorStyle] }],
  "ordered-list-item": [
    { processors: [removeInlineHeaderRanges, addInlineStyleRanges, fixTextColorStyle] }
  ],
  "unordered-list-item": [
    { processors: [removeInlineHeaderRanges, addInlineStyleRanges, fixTextColorStyle] }
  ],
  "code-block": [
    { processors: [removeInlineHeaderRanges, addInlineStyleRanges, fixTextColorStyle] }
  ],
  "header-one": [
    { processors: [removeInlineHeaderRanges, addInlineStyleRanges, fixTextColorStyle] }
  ],
  "header-two": [
    { processors: [removeInlineHeaderRanges, addInlineStyleRanges, fixTextColorStyle] }
  ],
  "header-three": [
    { processors: [removeInlineHeaderRanges, addInlineStyleRanges, fixTextColorStyle] }
  ],
  "header-four": [
    { processors: [removeInlineHeaderRanges, addInlineStyleRanges, fixTextColorStyle] }
  ],
  "header-five": [
    { processors: [removeInlineHeaderRanges, addInlineStyleRanges, fixTextColorStyle] }
  ],
  "header-six": [
    { processors: [removeInlineHeaderRanges, addInlineStyleRanges, fixTextColorStyle] }
  ],
  blockquote: [{ processors: [removeInlineHeaderRanges, addInlineStyleRanges, fixTextColorStyle] }]
};
const entityRangeProcessingStrategies = {
  LINK: [
    {
      version: "<3.4.7",
      processors: [addLinkUnderlineRange]
    }
  ]
};
const isVersionCompatible = (strategy, contentStateVersion) => strategy.version ? Version.evaluate(contentStateVersion, strategy.version) : true;
const applyStrategies = (strategies, processed, version, ...args) => {
  if (!strategies) {
    return processed;
  }
  let processedUnit = processed;
  strategies.filter((strategy) => isVersionCompatible(strategy, version)).forEach((strategy) => {
    strategy.processors.reduce((unit, processor) => {
      processedUnit = processor(unit, ...args);
      return processedUnit;
    }, processed);
  });
  return processedUnit;
};
const processContentState = (contentState, config) => {
  const { VERSION: contentStateVersion = "0.0.0" } = contentState;
  const processedState = applyStrategies(
    contentStateProcessingStrategies(config),
    contentState,
    contentStateVersion,
    config
  );
  const { blocks, entityMap, documentStyle } = processedState;
  return {
    blocks: blocks.map((block) => {
      let processedBlock = block;
      processedBlock = applyStrategies(
        blockProcessingStrategies[block.type],
        block,
        contentStateVersion,
        entityMap,
        config
      );
      if (processedBlock.entityRanges) {
        processedBlock.entityRanges.forEach((range) => {
          const entityType = entityMap && entityMap[range.key + ""] && entityMap[range.key + ""].type;
          if (entityType) {
            processedBlock = applyStrategies(
              entityRangeProcessingStrategies[entityType],
              processedBlock,
              contentStateVersion,
              range,
              entityMap,
              config
            );
          }
        });
      }
      processedBlock.inlineStyleRanges = removeInvalidInlineStyles(
        processedBlock.inlineStyleRanges
      );
      return processedBlock;
    }),
    entityMap,
    documentStyle,
    VERSION: Version.lessThan(contentStateVersion, Version.currentVersion) ? Version.currentVersion : contentStateVersion
  };
};

export { processContentState };
//# sourceMappingURL=processContentState.js.map
